import { lspGroupSetup } from "./lsp";
import { GroupSetupConfig } from "../../types/setupTypes";
import { shipperGroupSetup } from "./shipper";
import { carrierGroupSetup } from "./carrier";

export const groupSetups: GroupSetupConfig[] = [
  lspGroupSetup,
  shipperGroupSetup,
  carrierGroupSetup
];